import React from 'react';
import t from '~t';
import { useSelector, useDispatch } from 'react-redux';
import { set } from '~data/actions/config';

import { Label, Checkbox } from '~ui';

export default function SettingsAppNestViewLegacy() {
  const nested_view_legacy = useSelector(
    (state) => state.config.nested_view_legacy,
  );
  const dispatch = useDispatch();

  return (
    <>
      <Label>{t.s('nestedCollections')}</Label>
      <div>
        <Checkbox
          checked={nested_view_legacy}
          onChange={() =>
            dispatch(set('nested_view_legacy', !nested_view_legacy))
          }
        >
          {t.s('oldView')}
        </Checkbox>
      </div>
    </>
  );
}
